import api from './api';

export type EsferaParlamentar = 'MUNICIPAL' | 'ESTADUAL' | 'FEDERAL';

export interface CouncilorDTO {
  councilorId: string;
  fullName: string;
  politicalParty?: string;
  cpf?: string;
  esfera?: EsferaParlamentar;
  /** Número de 3 dígitos do parlamentar nas emendas municipais de 2027 em diante. */
  sequencialEmenda?: string | null;
  situacaoExcepcional?: boolean;
  motivoSituacaoExcepcional?: string | null;
  dataSituacaoExcepcional?: string | null;
  /** Marca o parlamentar como bancada. */
  bancada?: boolean;
  /** Login que atua como esta bancada. */
  responsavelUsuarioId?: number | null;
}

export interface ResponsavelCandidatoDTO {
  id: number;
  nomeCompleto: string;
  /** Só dígitos; ajuda a distinguir homônimos. */
  cpf?: string | null;
  /** Parlamentar pelo qual o login atua hoje, se houver. */
  parlamentarId?: string | null;
}

const councilorService = {
  list: async (): Promise<CouncilorDTO[]> => {
    const response = await api.get('/councilors');
    return response.data;
  },

  listarCandidatosResponsavel: async (): Promise<ResponsavelCandidatoDTO[]> => {
    const response = await api.get('/councilors/responsaveis-candidatos');
    return response.data;
  },

  getByCouncilorId: async (councilorId: string): Promise<CouncilorDTO> => {
    const response = await api.get(`/councilors/by-councilor-id/${encodeURIComponent(councilorId)}`);
    return response.data;
  },

  create: async (councilor: Partial<CouncilorDTO>): Promise<CouncilorDTO> => {
    const response = await api.post('/councilors', councilor);
    return response.data;
  },

  update: async (councilorId: string, councilor: Partial<CouncilorDTO>): Promise<CouncilorDTO> => {
    const response = await api.put(`/councilors/${encodeURIComponent(councilorId)}`, councilor);
    return response.data;
  },

  delete: async (councilorId: string): Promise<void> => {
    await api.delete(`/councilors/${encodeURIComponent(councilorId)}`);
  },
};

export const ESFERA_PARLAMENTAR_LABELS: Record<EsferaParlamentar, string> = {
  MUNICIPAL: 'Municipal',
  ESTADUAL: 'Estadual',
  FEDERAL: 'Federal',
};

export type { CouncilorDTO };
export { councilorService };
export default councilorService;
